import React from 'react';
import PropTypes from 'prop-types';

import { TableRow as MUITableRow } from '@mui/material';

export const TableRow = props => <MUITableRow {...props} />;

TableRow.propTypes = {
  classes: PropTypes.object,
  component: PropTypes.elementType,
  hover: PropTypes.bool,
  selected: PropTypes.bool
};

export default TableRow;
